module.exports = __webpack_public_path__ + "img/822e28273b3f3754941d74a203e18af5.svg";